import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.medications.medicationDetails;
export const medicationDetailsSelector = (state: RootState) => getState(state).data;
export const medicationDetailsActiveIdSelector = (state: RootState) => getState(state).activeId;
export const medicationDetailsIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const medicationDetailsErrorSelector = (state: RootState) => getState(state).error;
